export default __webpack_public_path__ + "static/media/js.081325c6.svg";